module.exports = __webpack_public_path__ + "img/mobile.dd36adbc.png";